import { Log } from "../../../../_common/js/concat/es/utils/Log.js";


// set up concat namespace
window.concat = window.concat || {};
window.concat.utils = window.concat.utils || {};

Log.info( "Messages", "testing..." );

//============================================================================
/**
 * postMessage handling library
 */
window.concat.utils.Messages = ( function() 
  {

    // private vars
    let self      = {};
    let _maxDepth = 0;
    let _depths   = new WeakMap();
    let _handlers = {};


    // helper func
    const _isValidProvider = ( p ) => !( !p || typeof p !== "string" || p === "" );

    //------------------------------------------------------------------------
    /**
     * Handler object
     * @param {string}   provider ID of the postMessage originator
     * @param {Function} callback function to fire when message is received
     * @param {Number}   depth    iterations of frame levels to listen for postMessage calls
     * @param {Boolean}  once     should the calllback only fire once
     */
    const Handler = function( provider, callback, depth = 0, once = false ) 
      {
        this.provider = provider;
        this.callback = callback;
        this.depth = depth;
        this.once = once;
        this.hasFired = false;
      }

    //------------------------------------------------------------------------
    /**
     * named callback function for a window's "message" event
     * @param {Object}  evt   event object
     */
    const _onMessage = ( evt ) =>
      {
        Log.info( "Messages", "_onMessage(), evt:", evt )

        let targDepth = _depths[evt.target.location.href];

        // validate message received
        const msg = evt.data;
        if( !msg || !_isValidProvider( msg.provider ) ) return;

        // iterative over all callbacks for the provider
        const arr = _handlers[ msg.provider ];
        arr && arr.forEach( handler => 
          {
            // Log.info( "  handler:", handler );
            if( targDepth > handler.depth )
              return;

            // vaidate if Handler's calback has already been fired
            if( handler.once && handler.hasFired )
              return;

            // do it.
            handler.hasFired = true;
            handler.callback( msg );
          });
      };

    //------------------------------------------------------------------------
    /**
     * sets up a new callback for a provider
     * @param  {[type]}   provider ID of postMessage originator
     * @param  {Function} callback function to fire when message is received
     * @param  {Boolean}  once     should the calllback only fire once
     * @return {Messages}          self reference for chaining
     */
    self.receive = ( provider, callback, depth = 0, once = false ) =>
      {
        Log.info( "Messages", "receive()" );
        // Log.info( "  depth:", depth );

        // validate arguments
        if( !_isValidProvider( provider ) ) return self;
        if( typeof callback !== "function" ) return self;

        // create an array if none exists for the provider
        if( !Array.isArray( _handlers[provider] ) )
          _handlers[provider] = [];

        // add a new Handler for the provider
        _handlers[provider].push( new Handler( provider, callback, depth, once ) );

        // update `_maxDepth`
        _maxDepth = depth > _maxDepth 
                  ? depth : _maxDepth;

        // Log.info( "Messages", `  h[${provider}]:`, _handlers[provider] );

        // success!
        return self;
      };

    //------------------------------------------------------------------------
    /**
     * removes one or all callbacks for a provider ID
     * @param  {String}        provider ID of postMessage originator
     * @param  {Function|null} callback function to remove. if null, all callbacks are removed
     * @return {Messages}               self reference for chaining
     */
    self.unreceive = ( provider, callback ) =>
      {
        Log.info( "Messages", "unreceive(), callback:", callback );

        // validate arguments
        if( typeof provider !== "string" || provider === "" )
          return self;
        if( !!callback && typeof callback !== "function" )
          return self;
        if( !Array.isArray( _handlers[provider] ) )
          return self;

        // clear all callbacks
        if( !callback )
          _handlers[provider].length = 0;
        // clear only the provided callback
        else
          _handlers[provider].splice( _handlers[provider].findIndex( hander => hander.callback === callback ), 1 );

        return self;
      };

    /**
     * remove all calbacks from all providers
     * @return {Messages}               self reference for chaining
     */
    self.unreceiveAll = () =>
      {
        Object.keys( _handlers ).forEach( key => 
          {
            self.unreceive( key );
          });
        return self;
      }

    //------------------------------------------------------------------------
    /**
     * start receiving messages
     * @return {Messages}               self reference for chaining
     */
    self.start = () => 
      { 
        Log.info( "Messages", "start()" );
        const setup = ( target, depth = 0 ) =>
          {
            Log.info( "  setup(), depth:", depth, "target:", target.location.href );

            if( depth < _maxDepth )
              Array.from( target.frames ).forEach( fr => { setup( fr, depth+1 ); } );

            _depths[target.location.href] = depth;
            target.addEventListener( "message", _onMessage, false );
          }

        setup( window );
        return self;
      };

    //------------------------------------------------------------------------
    /**
     * stop receiving messages
     * @return {Messages}               self reference for chaining
     */
    self.stop  = () => 
      { 
        Log.info( "Messages", "stop()" );
        const unsetup = ( target, depth = 0 ) =>
          {
            Log.info( "  unsetup(), depth:", depth, "target:", target.location.href );

            if( depth <= _maxDepth )
              Array.from( target.frames ).forEach( fr => { unsetup( fr, depth+1 ); } );

            target.removeEventListener( "message", _onMessage );
          }

        unsetup( window );
        return self;
      };

    return self;
  })();

